<template>
  <div id="gestor-apgos">
    <v-card class="v-card--material pa-3">
      <v-row>
        <v-col cols="3">
          <v-text-field v-model="total" color="gold" type="number" step="0.01" label="Total a pagar" :prefix="totales.simboloMoneda" readonly @change="comprobarMonto()" />
        </v-col>
        <v-col cols="3">
          <v-text-field v-model="totalRestante" color="gold" type="number" step="0.01" label="Saldo" :prefix="totales.simboloMoneda" readonly />
        </v-col>
        <v-col cols="3">
          <v-select v-model="metodosDePagoSelected" color="gold" :items="metodosPago" label="Metodos de pago" return-object item-text="descripcion">
            <template v-slot:itemm="{ attrs, itemm, on }">
              <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
                <v-list-item-content>
                  <v-list-item-title v-text="itemm.descripcion" />
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-select>
        </v-col>
        <v-spacer />
        <v-col cols="auto" class="pt-4">
          <v-btn color="gold" :disabled="registrarEnabled()" @click="registrarPago()">
            Agregar pago
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
    <slot name="informacionPago" />
    <detalle-recibo :lista-pagos="dataForm.registroDePagos" @anularPago="anularPago" />
    <registro-pagos :show="dialogRegistrarPago" :total-restante="totalRestante" :title="metodosDePagoSelected.descripcion"
                    :metodo-pago="metodosDePagoSelected"
                    @pagoGenerado="agregarPago($event)" @closeDialog="dialogRegistrarPago = $event"
    />
    <v-row justify="end">
      <v-col cols="auto">
        <v-btn :disabled="$disabled()" color="gold" class="mr-0" @click="grabarRecibo">
          Grabar pago
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import DetalleRecibo from './DetalleRecibo.vue'
  import RegistroPagos from './RegistroPagos.vue'
  import Vue from 'vue'

  export default {
    name: 'GestorPagos',
    components: {
      RegistroPagos,
      DetalleRecibo,
    },
    props: {
      totales: {
        type: Object,
        default: null,
        required: true,
      },
    },
    data () {
      return {
        bloquear: false,
        dialogRegistrarPago: false,
        total: 0,
        metodosDePagoSelected: {},
        metodosPago: [],
        totalRestante: 0,
        dataForm: {
          registroDePagos: [],
        },
      }
    },
    watch: {
      totales (val) {
        this.total = val.totalAPagar
        this.totalRestante = val.totalAPagar
        this.dataForm.registroDePagos = []
      },
      total (val) {
        this.totalRestante = parseFloat(val)
      },
    },
    created () {
      this.updateMetodosDePago()
    },
    methods: {
      comprobarMonto () {
        this.total = parseFloat(this.total)
        if (this.total > this.totales.totalMaximo) {
          this.total = this.totales.totalMaximo
          this.$store.commit('toast/show', { tipo: 'error', messages: ['El monto elegido supera la deuda total'] })
        }
      },
      registrarEnabled () {
        if (this.total === 0.00 || this.metodosDePagoSelected === null ||
          Object.entries(this.metodosDePagoSelected).length === 0 || this.totalRestante === 0) {
          return true
        }
        return false
      },
      anularPago (pago) {
        this.totalRestante += pago.montoACubrir
        const index = this.dataForm.registroDePagos.indexOf(pago)
        if (index > -1) {
          this.dataForm.registroDePagos.splice(index, 1)
        }
        if (pago.metodopago.descripcion === 'Tarjeta') {
          this.updateMetodosDePago()
        }
      },
      registrarPago () {
        this.bloquear = true
        this.dialogRegistrarPago = true
      },
      agregarPago (nuevoPago) {
        this.dialogRegistrarPago = false
        this.totalRestante -= nuevoPago.montoACubrir
        const indexReg = this.dataForm.registroDePagos.length
        Vue.set(this.dataForm.registroDePagos, indexReg, nuevoPago)
        if (nuevoPago.metodopago.descripcion === 'Tarjeta') {
          this.updateMetodosDePagoTarjeta()
        }
      },
      updateMetodosDePago () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/metodo_pago/1' }).then(response => {
          this.metodosPago = response
        })
      },
      updateMetodosDePagoTarjeta () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/metodo_pago_tarjeta' }).then(response => {
          this.metodosPago = response
        })
      },
      grabarRecibo () {
        if (this.totalRestante !== 0.00) {
          this.$store.commit('toast/show', { tipo: 'error', messages: ['Aún queda saldo restante'] })
        } else if (this.dataForm.registroDePagos.length === 0) {
          this.$store.commit('toast/show', { tipo: 'error', messages: ['Nada que aplicar'] })
        } else {
          this.$emit('enviarPaquete', this.dataForm)
        }
      },
    },
  }
</script>
